export enum CallSentMethodEnum {
        GlobalOverride = 5165,
        PrimaryCareProvider = 5166,
        RoundingProvider = 5167,
        AHT = 5159,
        OnCallProvider = 5160,
        LocalOverride = 5161,
        SecondaryProvider = 5202
}
